"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LinkToAnotherRecordColumn;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _index = require("~/models/index");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let LinkToAnotherRecordColumn = class LinkToAnotherRecordColumn {
    async getChildColumn(context, ncMeta = _Noco.default.ncMeta) {
        const { childContext } = await this.getParentChildContext(_extends({}, context, {
            base_id: this.base_id
        }));
        return this.childColumn = await _Column.default.get(childContext, {
            colId: this.fk_child_column_id
        }, ncMeta);
    }
    async getMMChildColumn(context, ncMeta = _Noco.default.ncMeta) {
        const { mmContext } = this.getRelContext(_extends({}, context, {
            base_id: this.base_id
        }));
        return this.mmChildColumn = await _Column.default.get(mmContext, {
            colId: this.fk_mm_child_column_id
        }, ncMeta);
    }
    async getParentColumn(context, ncMeta = _Noco.default.ncMeta) {
        const { parentContext } = await this.getParentChildContext(_extends({}, context, {
            base_id: this.base_id
        }));
        return this.parentColumn = await _Column.default.get(parentContext, {
            colId: this.fk_parent_column_id
        }, ncMeta);
    }
    async getMMParentColumn(context, ncMeta = _Noco.default.ncMeta) {
        const { mmContext } = this.getRelContext(_extends({}, context, {
            base_id: this.base_id
        }));
        return this.mmParentColumn = await _Column.default.get(mmContext, {
            colId: this.fk_mm_parent_column_id
        }, ncMeta);
    }
    async getMMModel(context, ncMeta = _Noco.default.ncMeta) {
        const { mmContext } = this.getRelContext(context);
        return this.mmModel = await _Model.default.getByIdOrName(mmContext, {
            id: this.fk_mm_model_id
        }, ncMeta);
    }
    async getRelatedTable(context, ncMeta = _Noco.default.ncMeta) {
        const { refContext } = this.getRelContext(_extends({}, context, {
            base_id: this.base_id
        }));
        return this.relatedTable = await _Model.default.getByIdOrName(refContext, {
            id: this.fk_related_model_id
        }, ncMeta);
    }
    static async insert(context, data, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(data, [
            'fk_column_id',
            'type',
            'fk_child_column_id',
            'fk_parent_column_id',
            'fk_mm_model_id',
            'fk_mm_child_column_id',
            'fk_mm_parent_column_id',
            'fk_target_view_id',
            'ur',
            'dr',
            'fk_index_name',
            'fk_related_model_id',
            'virtual',
            'fk_related_base_id',
            'fk_mm_base_id',
            'fk_related_source_id',
            'fk_mm_source_id',
            'version'
        ]);
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, insertObj);
        return this.read(context, data.fk_column_id, ncMeta);
    }
    async getChildView(context, table = undefined, ncMeta = _Noco.default.ncMeta) {
        var _ref, _this_fk_target_view_id;
        var _table_views_, _table_views;
        await (table == null ? void 0 : table.getViews(context));
        const viewId = (_ref = (_this_fk_target_view_id = this.fk_target_view_id) != null ? _this_fk_target_view_id : table == null ? void 0 : (_table_views = table.views) == null ? void 0 : (_table_views_ = _table_views[0]) == null ? void 0 : _table_views_.id) != null ? _ref : '';
        if (!viewId) return;
        return await _index.View.get(context, viewId, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let colData = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_RELATION}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!colData) {
            colData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_RELATION}:${columnId}`, colData);
        }
        return colData ? new LinkToAnotherRecordColumn(colData) : null;
    }
    static async update(_context, _fk_column_id, _param) {
    // placeholder method
    }
    getRelContext(context) {
        if (this._context) {
            return this._context;
        }
        let refContext = context;
        let mmContext = context;
        // if the related table is in different base
        if (this.fk_related_base_id && this.fk_related_base_id !== context.base_id) {
            refContext = _extends({}, context, {
                base_id: this.fk_related_base_id
            });
        }
        // if the junction table is in different base
        if (this.fk_mm_base_id && this.fk_mm_base_id !== context.base_id) {
            mmContext = _extends({}, context, {
                base_id: this.fk_mm_base_id
            });
        }
        // propagate cache map
        if (context.cacheMap) {
            refContext.cacheMap = context.cacheMap;
            if (mmContext) mmContext.cacheMap = context.cacheMap;
        }
        return this._context = {
            refContext,
            mmContext
        };
    }
    async getParentChildContext(context, column, ncMeta = _Noco.default.ncMeta) {
        if (this._parentChildContext) {
            return this._parentChildContext;
        }
        const { refContext, mmContext } = this.getRelContext(_extends({}, context, {
            base_id: this.base_id
        }));
        let childContext = context;
        let parentContext = context;
        if (this.fk_related_base_id) {
            const col = column || await _Column.default.get(context, {
                colId: this.fk_column_id
            }, ncMeta);
            // V2 om/mo/mm all use junction tables — parent always in related table
            if ((0, _nocodbsdk.isMMOrMMLike)(col)) {
                parentContext = refContext;
            } else if (this.type === _nocodbsdk.RelationTypes.HAS_MANY) {
                // hm: child (FK column) belongs to the related table
                childContext = refContext;
            } else if (this.type === _nocodbsdk.RelationTypes.BELONGS_TO) {
                // bt: parent (PK column) belongs to the related table
                parentContext = refContext;
            } else if (this.type === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                var _col_meta;
                // oo: depends on which side holds the FK
                if (col == null ? void 0 : (_col_meta = col.meta) == null ? void 0 : _col_meta.bt) {
                    parentContext = refContext;
                } else {
                    childContext = refContext;
                }
            }
        }
        // propagate cache map
        if (context.cacheMap) {
            refContext.cacheMap = context.cacheMap;
            if (mmContext) mmContext.cacheMap = context.cacheMap;
            childContext.cacheMap = context.cacheMap;
            parentContext.cacheMap = context.cacheMap;
        }
        return this._parentChildContext = {
            childContext,
            parentContext,
            mmContext,
            refContext
        };
    }
    isCrossBaseLink() {
        return !!(this.fk_related_base_id && this.fk_related_base_id !== this.base_id || this.fk_mm_base_id && this.fk_mm_base_id !== this.base_id);
    }
    constructor(data){
        Object.assign(this, _extends({
            virtual: false
        }, data));
    }
};
